import useTranslation from 'next-translate/useTranslation';
import React, { Fragment } from 'react';
import { Rims } from 'types/Rims';
import { SelectItem } from '../CategoryFilter.styled';

type Props = {
  rims: Rims;
  selectedRimSize: number | null;
  selectedPitchCircle?: number | null;
  setSelectedPitchCircleDiameter: React.Dispatch<React.SetStateAction<number | null>>;
  setSelectedRimSize: React.Dispatch<React.SetStateAction<number | null>>;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

export default React.memo(function RimsFilter({
  rims,
  selectedPitchCircle,
  selectedRimSize,
  setSelectedPitchCircleDiameter,
  setSelectedRimSize,
  setCurrent,
}: Props) {
  const { t } = useTranslation('common');

  const diameterOptions = rims.pitch_circles.map((diameter) => ({
    label: diameter.name,
    value: diameter.id,
  }));

  const sizeOptions = rims.rim_size.map((size) => ({
    label: size.diameter,
    value: size.id,
  }));

  return (
    <Fragment>
      <SelectItem
        placeholder={t('select-rim')}
        value={sizeOptions.find((size) => size.value === selectedRimSize) || null}
        options={sizeOptions}
        isClearable
        onChange={(option: any) => {
          setSelectedPitchCircleDiameter(null);
          setSelectedRimSize(option?.value || null);
          setCurrent(1);
        }}
      />
      <SelectItem
        placeholder={t('pitch-circle-diameter')}
        value={diameterOptions.find((diam) => diam.value === selectedPitchCircle) || null}
        options={diameterOptions}
        isDisabled={!Boolean(selectedRimSize)}
        onChange={(option: any) => {
          setSelectedPitchCircleDiameter(option.value || null);
          setCurrent(1);
        }}
      />
    </Fragment>
  );
});
